// const fsb = require('./fsb');
// const path = require('path');
// const beautify = require('js-beautify').html;

import { html as beautify } from 'js-beautify';
import {handleAnimate, roundedRectPath, drawGroupRect, ellipseToPath} from './funcHtml.js';

let unique=0;
let bodyColor = "#dddddd";
let demo = false;
let preview = false;


export function toHtml(t, user,d, p)
{ 
    demo = d;
    if(p)
    {
      preview = p;
    }

    console.log("Demo: ", d);
    console.log("Name: ", t.pages[0].pageInfo.name)
    
    if(t.navigation.method === 'scroll')
    {
        return createScrollHtml(user, t);
    }    
    else
    {
        return createLinkedHtml(user,t);
    }
    // console.log("Exiting toHtml");
}

function createScrollHtml(user, t)
{    
    let mediaString = ""; //generateMediaQueries(t.devices, t.pagesForDevice);
    let scriptString = generateDeviceScript(t, t.devices, t.pagesForDevice);    
    let pages = generatePages(user, t.pages, t.devices);
    return writePages(user, mediaString, pages, scriptString,t.devices, t.pages[0].pageInfo.name);
}

function createLinkedHtml(user, t)
{    
    let mediaString = ""; //generateMediaQueries(t.devices, t.pagesForDevice);
    let scriptString = generateDeviceScript(t, t.devices, t.pagesForDevice, t.pages);    
    let pages = generateLinkedPages(user,t.pages, t.devices);
    return writePages(user, mediaString, pages, scriptString,t.devices, t.pages[0].pageInfo.name);
}


function generateMediaQueries(devices, pagesForDevice) {
    let cssString = '';

    // Loop through each device size
    let dId = 0;
    devices.forEach(device => {
        const deviceName = device.name;
        const minWidth = device.minWidth;
        const maxWidth = device.maxWidth;        

        // Start a media query block for each device
        cssString += `\n/* ${deviceName}: ${minWidth}-${maxWidth}px */\n`;
        cssString += `@media (min-width: ${minWidth}px) and (max-width: ${maxWidth}px) {\n`;

        // Loop through pages for each device and generate the CSS rules



        if (pagesForDevice[deviceName]) {

          /*
          cssString += `\t.page[data-bp="${dId}"],\n`;
          cssString += `\t.page[data-bp="all"] {\n`;
          cssString += `\t\t display:block;\n`;
          cssString += `\t}`;
          */

          pagesForDevice[deviceName].forEach(page => {
                const pageId = page.id;
                const pageName = page.name;
                // let lastChar = pageId.charAt(pageId.length -1);
                
                // Add CSS rule for each page
                cssString += `\t#page-${pageId} { display: block; order: 1; }\n`;
            });
        }

        // Close the media query block
        cssString += `}\n`;
         dId++;
    });

    return cssString;
}

// Function to generate page layout
function generatePages(user, pages,devices) {
    bodyColor = pages[0].pageInfo.browserBackground;

    return pages.map(page => {
        const { pageId, layout, pageInfo, pageWidth, pageHeight } = page;
        const rectangles = generateRectangles(user, layout);

        let aiInstruction = "";
        if(pageInfo?.pageTheme != "")
        {
            aiInstruction  = `data-ai-instruction="${pageInfo?.pageTheme}"`;
        }

        let dataPage = pageId.split("_")[0];
        let lastChar = pageId.charAt(pageId.length -1);

        /*
        return `
        <div id="data-page=${dataPage}" data-bp="${lastChar}" ${aiInstruction} class="page">
            ${rectangles}
        </div>`;
        */

        let index = pageId.split("_")[1];
        let indexInt = parseInt(index);
        
        let className = devices[indexInt].name;

        let pageW = parseInt(pageWidth);
        let pageH = parseInt(pageHeight);


        // Build page background style
        let backgroundStyle = "";

        if (page.pageInfo.fillMode === "gradient")
        {

            const angle = (parseFloat(page.pageInfo.gradientAngle || 0) + 90);
            backgroundStyle = `
                background: linear-gradient(
                    ${angle}deg,
                    ${page.pageInfo.gradientColor1 || "#ffffff"},
                    ${page.pageInfo.gradientColor2 || "#000000"}
                );
            `;
        }
        else
        {
            backgroundStyle = `
                background-color: ${page.pageInfo.pageBackground || "#ffffff"};
            `;
        }

        return `
        <div id="page-${pageId}" ${aiInstruction} class="page ${className}" style="${backgroundStyle}; width: ${pageW}px; height: ${pageH}px;margin-bottom: ${page.pageInfo.marginBottom}px;margin-top: ${page.pageInfo.marginTop}px;"" >
            ${rectangles}
        </div>`;

    }).join('');
}


// Function to generate page layout
function generateLinkedPages(user, pages,devices) {
  bodyColor = pages[0].pageInfo.browserBackground;
  


  return pages.map(page => {
      const { pageId, layout, pageInfo, pageWidth, pageHeight } = page;
      const rectangles = generateRectangles(user, layout);

      let aiInstruction = "";
      if(pageInfo?.pageTheme != "")
      {
          aiInstruction  = `data-ai-instruction="${pageInfo?.pageTheme}"`;
      }

      let dataPage = pageId.split("_")[0];
      let lastChar = pageId.charAt(pageId.length -1);


      /*
      return `
      <div id="data-page=${dataPage}" data-bp="${lastChar}" ${aiInstruction} class="page">
          ${rectangles}
      </div>`;
      */

      let index = pageId.split("_")[1];
      let indexInt = parseInt(index);
      
      let className = devices[indexInt].name;

      let pageW = parseInt(pageWidth);
      let pageH = parseInt(pageHeight);

      /*
      style="
      position:absolute;
      top:0;
      left:0;
      background-color:${page.pageInfo.pageBackground};
      width:${pageW}px;
      height:${pageH}px;
      z-index:${indexInt};
      "
      */
          
      return `
            <div id="page-${pageId}" ${aiInstruction} class="page ${className}" 
              style="
              position:absolute;
              top:50%;
              left:50%;
              transform:translate(-50%, -50%);
              background-color:${page.pageInfo.pageBackground};
              width:${pageW}px;
              height:${pageH}px;
              z-index:${indexInt};
              ">
                ${rectangles}
            </div>`;

  }).join('');
}

// Function to generate rectangles
function generateRectangles(user, layout) {  
  let result = [];
  let groupDepth = 0;
  let groupLocalLink = "";
  let groupExternalLink = "";

  const queue = [...layout];  // Initialize the queue with the layout

  while (queue.length > 0) {
    const item = queue.shift();  // Get the first item from the queue

    // Handle end marker
    if (item === "__END_GROUP__") {      
      groupDepth--;
      if(groupDepth === 0)
      {
        groupLocalLink = "";
        groupExternalLink = "";
      }
      result.push(`
      </div>`);

      continue;
    }

    unique++;
    
    if (item.type === 'Rectangle') 
    {

      if (item.subType === 'AiArt') 
      {
        const { x, y, w, h, id: idT, zIndex, richText, description } = item;
        let id = (idT.trim() + `_${unique}`).trim();

        let aiInstruction = "";
        if (description !== "") {
          aiInstruction = `data-ai-instruction="${description}"`;
        }

        let content = richText;
        let placeholderStyle = `
            background: rgba(128, 128, 128, 0.12);
            border: 1px dashed rgba(128, 128, 128, 0.45);
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgba(80, 80, 80, 0.7);
            font-family: Arial, sans-serif;
            font-size: 14px;
            text-align: center;
          `;

          content = "AI Generated Vector or Image — add content here";


        result.push(`
          <div id="${id}" ${aiInstruction} class="rectangle text"
            style="left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex}; ${placeholderStyle}">
            ${content}
          </div>`);
      }

      if (item.subType === 'Text') 
      {
        const { x, y, w, h, id: idT, zIndex, richText, description } = item;
        let id = (idT.trim() + `_${unique}`).trim();

        let aiInstruction = "";
        if (description !== "") {
          aiInstruction = `data-ai-instruction="${description}"`;
        }

        let content = richText;
        let placeholderStyle = "";

        if (richText === "") {
          placeholderStyle = `
            background: rgba(128, 128, 128, 0.12);
            border: 1px dashed rgba(128, 128, 128, 0.45);
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgba(80, 80, 80, 0.7);
            font-family: Arial, sans-serif;
            font-size: 14px;
            text-align: center;
          `;

          content = "Text area — add content here";
        }

        result.push(`
          <div id="${id}" ${aiInstruction} class="rectangle text"
            style="left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex}; ${placeholderStyle}">
            ${content}
          </div>`);
      }

      if (item.subType === 'Custom') 
      {    
        const { x, y, w, h, id: idT, zIndex, rotation, imageName, description, aiCode, keepAspect, enablePopup, clickable, useLocal, localLink, externalLink } = item;
        let id = (idT.trim() + `_${unique}`).trim();
                
        let aiInstruction = "";
        if (description !== "") {
          aiInstruction = `data-ai-instruction="${description}"`;
        }
        
        let placeholderStyle = "";
        if (!aiCode || aiCode === "") {
          placeholderStyle = `
            background: rgba(128, 128, 128, 0.12);
            border: 1px dashed rgba(128, 128, 128, 0.45);
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgba(80, 80, 80, 0.7);
            font-family: Arial, sans-serif;
            font-size: 14px;
            text-align: center;
          `;

          let content = "AI Generated Code — add content here";


          result.push(`
            <div id="${id}" ${aiInstruction} class="rectangle text"
              style="left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex}; ${placeholderStyle}">
              ${content}
            </div>`);
        }
        else
        {

          console.log("aiCode: ", aiCode);

            let base = `https://myaiweb.ca/${user}/`;

            if (demo === true) {
                base = "https://ait.myaiweb.ca/";
            }

            // const baseTag = `<base id="baseUrl" href="${base}">`;
            // const parentOrigin = window.location.origin;

            // was inside script. Commented here
            // const base = document.getElementById("baseUrl");
            // let url = new URL(window.location.href);
            // base.href = url.origin + "/${user}/";
            // window.parentOrigin = "${parentOrigin}"
                      
            const wrapper = `                
                <script>                    
                    console.log("About to initialize Three.js");
                    console.log("Base Tag: ", window.parent.location.origin);
                    window.threeReady = import(window.parent.location.origin + "/three/three.module.js")
                        .then((THREE) => {

                            console.log("Got three.module.js");

                            window.THREE = THREE;

                            console.log("Three.js initialized");

                            return THREE;

                        })
                        .catch((error) => {
                          
                            console.error("Three.js initialization failed:", error);

                            throw error;

                        });

                </script>
                ${aiCode}
            `;

            // Convert the complete iframe HTML into a JavaScript string.
            // Escape </script> so the OUTER script cannot accidentally terminate.
            const wrapperForScript = JSON.stringify(wrapper)
              .replace(/<\/script/gi, '<\\/script');

            result.push(`
                <div id="${id}" ${aiInstruction} class="rectangle"
                    style="padding:0;margin:0;left:${x}px;top:${y}px;width:${w}px;height:${h}px;z-index:${zIndex};overflow:hidden;transform:rotate(${-rotation}deg);">

                    <iframe
                        id="${id}-iframe"
                        style="width:100%;height:100%;border:none;"
                        sandbox="allow-scripts allow-same-origin allow-top-navigation">
                    </iframe>

                    <script>
                        {
                          let iframe = document.getElementById(${JSON.stringify(`${id}-iframe`)});
                          iframe.srcdoc = ${wrapperForScript};
                        }
                    </script>

                </div>
            `);
           
        }
      }

      if (item.subType === 'Image') 
      {
    
        const { x, y, w, h, id: idT, zIndex, rotation, imageName, description, keepAspect, enablePopup, clickable, useLocal, localLink, externalLink } = item;
        let id = (idT.trim() + `_${unique}`).trim();
                
        let aiInstruction = "";
        if (description !== "") {
          aiInstruction = `data-ai-instruction="${description}"`;
        }

        if(imageName === "")
        {

          let placeholderStyle = "";
  
          placeholderStyle = `
              background: rgba(128, 128, 128, 0.12);
              border: 1px dashed rgba(128, 128, 128, 0.45);
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: center;
              color: rgba(80, 80, 80, 0.7);
              font-family: Arial, sans-serif;
              font-size: 14px;
              text-align: center;
            `;
  
          let content = "Image area — add content here";

  
          result.push(`
            <div id="${id}" ${aiInstruction} class="rectangle text"
              style="left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex}; ${placeholderStyle}">
              ${content}
            </div>`);
  
        }
        else
        {
            let fullPath = imageName;
            let refresh = "";

            if (!preview) {
                refresh = "?v=" + new Date().getTime();
            }

            if (demo === true) {
                fullPath = `images/${imageName}` + refresh;
            } else {
                fullPath = `./${imageName}` + refresh;
            }

            let onClick = '';
            if(clickable)
            {
              if(localLink && localLink != "")
              {
                let func = `goToPage('${localLink}')`;
                onClick = `onClick="${func}"`;
              }
              if(externalLink && externalLink != "")
              {
                let func = `goToExternalPage('${externalLink}')`;
                onClick = `onClick="${func}"`;
              }

            }
            //<div id="${id}" ${aiInstruction} class="rectangle image" style="left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex}; background-image: url('${fullPath}');">


            // <div id="${id}" ${aiInstruction} class="rectangle" style="left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex};overflow: hidden; transform: rotate(${rotation}deg);">
          // <img src=${fullPath} style="position:absolute; top:50%;left:50%; width:${widthS}; height: ${heightS}; object-fit: ${fitS};transform: translate(-50%,-50%);" />
            //  </div>`);

            let widthS ="100%";
            let heightS ="100%";
            let fitS = "";
            
            if(keepAspect === true)
            {          
              fitS = "object-position: top left;display:block;object-fit:contain;";
              widthS = "auto";
              heightS = "auto";
            }
            let popup="";

            if(enablePopup===true)
            {
              popup = "class='popup-image'";
            }
            
            result.push(`
              <div id="${id}" ${aiInstruction} class="rectangle" ${onClick}  style="padding:0;margin:0;left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex};overflow: hidden; transform: rotate(${-rotation}deg);">
                <img src=${fullPath} style="width: 100%; height: 100%; ${fitS}" ${popup}    data-rotation="${-rotation}"/>
              </div>`);
          }

      }

      if (item.subType === 'SvgCircle') 
      {
  
    
        const { x, y, w, h, id: idT, zIndex, rotation, 
                imageName, description, keepAspect, enablePopup, 
                clickable, useLocal, localLink, externalLink,
                fillColor, strokeColor, strokeWidth,allowStroke,allowFill, imagePanX, imagePanY, imageZoom, fillAlpha} = item;
        let id = (idT.trim() + `_${unique}`).trim();



        let filterId = `filter-${id}`;
        let filterStr = "";

        if (item.isBlur || item.isDropShadow) {
          filterStr = `
            <filter id="${filterId}" x="-50%" y="-50%" width="200%" height="200%">
              ${item.isDropShadow ? `<feDropShadow dx="${item.shadowOffsetX}" dy="${item.shadowOffsetY}" stdDeviation="${item.shadowBlur}" flood-color="${item.shadowColor}" />` : ""}
              ${item.isBlur ? `<feGaussianBlur stdDeviation="${item.regularBlur}" />` : ""}
            </filter>
          `;
        }
                
        let aiInstruction = "";
        if (description !== "") {
          aiInstruction = `data-ai-instruction="${description}"`;
        }

        let opacity = fillAlpha;

        let refresh = "";
        if (!preview) {
          refresh = "?v=" + new Date().getTime();
        }

        let fullPath = imageName;
        if (demo === true) {
            fullPath = `images/${imageName}` + refresh;
        } else {
            fullPath = `./${imageName}` + refresh;
        }
  
        let onClick = '';
        if(clickable)
        {
          let ll = localLink;
          let ee = externalLink;

          if(groupDepth !== 0)
          {
            ll = groupLocalLink;
            ee = groupExternalLink;
          }

          if(ll && ll != "")
          {
            let func = `goToPage('${ll}')`;
            onClick = `onClick="${func}"`;
          }
          if(ee && ee != "")
          {
            let func = `goToExternalPage('${ee}')`;
            onClick = `onClick="${func}"`;
          }

        }
  

        let fill = "";
        let gradientDef = "";
        let fillValue = fill;
        
        if (item.allowFill && item.fillMode === "gradient") {
        
          const angle = (item.gradientAngle || 0) * Math.PI / 180;
        
          const dx = Math.cos(angle);
          const dy = Math.sin(angle);
        
          const gradId = `grad-${id}`;
        
          gradientDef = `
            <defs>
              <linearGradient id="${gradId}" x1="${50 - dx * 50}%" y1="${50 - dy * 50}%" x2="${50 + dx * 50}%" y2="${50 + dy * 50}%">
                <stop offset="0%" stop-color="${item.gradientColor1}" />
                <stop offset="100%" stop-color="${item.gradientColor2}" />
              </linearGradient>
            </defs>
          `;
        
          fillValue = `fill="url(#${gradId})"`;
        
        } else if (item.allowFill) {
          fillValue = `fill="${item.fillColor}"`;
        } else {
          fillValue = `fill="transparent"`;
        }

  
        if(allowFill)
        {
          fill = `fill="${fillColor}"`;
        }
        else
        {
          fill = `fill="transparent"`;
        }
  
        let stroke = "";
        if(allowStroke)
        {
          stroke = `stroke="${strokeColor}" stroke-width="${strokeWidth}"`;
        }

        let popup="";

        if(enablePopup===true)
        {
          popup = "class='popup-image'";
        }
                    
        // Calculate the new width/height of the viewBox based on zoom
        let newViewBoxWidth = w ;  // 160 is the original width of the rectangle
        let newViewBoxHeight = h; // 120 is the original height of the rectangle

        // Calculate the new origin of the viewBox (this is where pan will apply)
        let newViewBoxX = 0
        let newViewBoxY = 0
                
        let cX = w/2;
        let cY = h/2;
        

        let radius = w/2;
        let offset = item.shadowOffsetX;

        if(h < w)
        {
          radius = h/2 - strokeWidth/2;
          offset = item.shadowOffsetY;
        }

        let sw = radius-strokeWidth/2;

        if(item.isDropShadow)
        {
          sw = sw - Math.abs(offset) - item.shadowBlur;
        }
        if(item.isBlur)
        {
          sw = sw - item.regularBlur;
        }

        let r = `r="${sw}"`


        let iW = imageZoom*sw*2;
        let iH = imageZoom*sw*2;

        // Update the viewBox with the new values
        let viewBoxStr = `${newViewBoxX} ${newViewBoxY} ${newViewBoxWidth} ${newViewBoxHeight}`;

        // <circle cx="${cX}" cy="${cY}" ${r} ${fill} ${stroke}"/>
        // <circle cx="${cX}" cy="${cY}" ${r} ${fill} ${stroke} opacity="${opacity}" ${filterStr ? `filter="url(#${filterId})"` : ""}/>

        let d = ellipseToPath(cX, cY, sw, sw);
        // transform="translate(${cX-r},${cY-r})"
        if(imageName !="")
        {
          result.push(`

              <div id="${id}" ${aiInstruction} class="rectangle" 
                      style="padding:0;margin:0;left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex}; overflow: hidden; transform: rotate(${-rotation}deg);">
                  
                    <svg width="${w}" height="${h}" overflow="visible" viewBox="${viewBoxStr}" ${onClick} ${popup} data-rotation="${-rotation}" data-large="${fullPath}">
                        <defs>
                            <clipPath id="clip-${id}">
                                <!-- Define your clipping path, in this case, a circle -->                                                                
                                <path d="${d}" ${fill} ${stroke} opacity="${opacity}" />                                                    
                            </clipPath>

                            ${filterStr} 
                        </defs>
                  
                        <circle cx="${cX}" cy="${cY}" ${r} ${fill} ${stroke} opacity="${opacity}" ${filterStr ? `filter="url(#${filterId})"` : ""}/>                        
                        <!-- Wrap the image in a <g> and apply the clip-path to the group -->
                        <g ${filterStr ? `filter="url(#${filterId})"` : ""}
                          <g clip-path="url(#clip-${id})" opacity="${opacity}" >
                              <image
                                  href="${fullPath}"
                                  transform="translate(${cX - iW / 2+ imagePanX*imageZoom}, ${cY - iH / 2 + imagePanY*imageZoom})"
                                  width="${iW}"    <!-- Dynamically set the width based on zoom -->
                                  height="${iH}"   <!-- Dynamically set the height based on zoom -->   
                                  preserveAspectRatio = "none"
                                  
                              />
                          </g>
                        </g>                                                  
                    </svg>
                  </div>
                  
                    `);
        
        }
        else        
        {

          result.push(`
            <div id="${id}" ${aiInstruction} class="rectangle" 
                style="padding:0;margin:0;left: ${x}px; top: ${y}px; 
                      width: ${w}px; height: ${h}px; z-index: ${zIndex}; 
                      overflow: hidden; transform: rotate(${-rotation}deg);">
              <svg ${onClick} width="100%" height="100%" viewBox="0 0 ${w} ${h}">  <!-- No scaling of viewBox -->
                ${gradientDef}
                <defs>
                  ${filterStr} 
                </defs>
                <path d="${d}" ${fillValue} ${stroke} opacity="${opacity}" ${filterStr ? `filter="url(#${filterId})"` : ""}/>                                                
              </svg>        
            </div>`);

        }  
      }

      if (item.subType === 'SvgEllipse') 
      {
  
    
        const { x, y, w, h, id: idT, zIndex, rotation, 
                imageName, description, keepAspect, enablePopup, 
                clickable, useLocal, localLink, externalLink,
                fillColor, strokeColor, strokeWidth,allowStroke,allowFill, fillAlpha, imagePanX, imagePanY, imageZoom, 
                iX,iY, iW, iH} = item;
        let id = (idT.trim() + `_${unique}`).trim();
                

        let filterId = `filter-${id}`;
        let filterStr = "";

        if (item.isBlur || item.isDropShadow) {
          filterStr = `
            <filter id="${filterId}" x="-50%" y="-50%" width="200%" height="200%">
              ${item.isDropShadow ? `<feDropShadow dx="${item.shadowOffsetX}" dy="${item.shadowOffsetY}" stdDeviation="${item.shadowBlur}" flood-color="${item.shadowColor}" />` : ""}
              ${item.isBlur ? `<feGaussianBlur stdDeviation="${item.regularBlur}" />` : ""}
            </filter>
          `;
        }

        let opacity = fillAlpha;

        let aiInstruction = "";
        if (description !== "") {
          aiInstruction = `data-ai-instruction="${description}"`;
        }
  
        let refresh = "";
        if (!preview) {
          refresh = "?v=" + new Date().getTime();
        }
        let fullPath = imageName;
        if (demo === true) {
            fullPath = `images/${imageName}` + refresh;
        } else {
            fullPath = `./${imageName}` + refresh;
        }
  
        let onClick = '';
        if(clickable)
        {
          let ll = localLink;
          let ee = externalLink;

          if(groupDepth !== 0)
          {
            ll = groupLocalLink;
            ee = groupExternalLink;
          }

          if(ll && ll != "")
          {
            let func = `goToPage('${ll}')`;
            onClick = `onClick="${func}"`;
          }
          if(ee && ee != "")
          {
            let func = `goToExternalPage('${ee}')`;
            onClick = `onClick="${func}"`;
          }

        }
  
        let fill = "";
        let gradientDef = "";
        let fillValue = fill;
        
        if (item.allowFill && item.fillMode === "gradient") {
        
          const angle = (item.gradientAngle || 0) * Math.PI / 180;
        
          const dx = Math.cos(angle);
          const dy = Math.sin(angle);
        
          const gradId = `grad-${id}`;
        
          gradientDef = `
            <defs>
              <linearGradient id="${gradId}" x1="${50 - dx * 50}%" y1="${50 - dy * 50}%" x2="${50 + dx * 50}%" y2="${50 + dy * 50}%">
                <stop offset="0%" stop-color="${item.gradientColor1}" />
                <stop offset="100%" stop-color="${item.gradientColor2}" />
              </linearGradient>
            </defs>
          `;
        
          fillValue = `fill="url(#${gradId})"`;
        
        } else if (item.allowFill) {
          fillValue = `fill="${item.fillColor}"`;
        } else {
          fillValue = `fill="transparent"`;
        }

        if(allowFill)
        {
          fill = `fill="${fillColor}"`;
        }
        else
        {
          fill = `fill="transparent"`;
        }
  
        let stroke = "";
        if(allowStroke)
        {
          stroke = `stroke="${strokeColor}" stroke-width="${strokeWidth}"`;
        }

        let popup="";

        if(enablePopup===true)
        {
          popup = "class='popup-image'";
        }

        let strokeNum = parseInt(strokeWidth);
        // Calculate the new width/height of the viewBox based on zoom
        let newViewBoxWidth = w + strokeNum+1;  // 160 is the original width of the rectangle
        let newViewBoxHeight = h + strokeNum+1; // 120 is the original height of the rectangle

        // Calculate the new origin of the viewBox (this is where pan will apply)
        let newViewBoxX = 0
        let newViewBoxY = 0
                
        let cX = w/2;
        let cY = h/2;
        

        let swX = cX - strokeNum/2;
        let swY = cY - strokeNum/2;

        if(item.isDropShadow)
        {
          swX = swX - Math.abs(item.shadowOffsetX) - item.shadowBlur;
          swY = swY - Math.abs(item.shadowOffsetY) - item.shadowBlur;
        }
        if(item.isBlur)
        {
          swX = swX - item.regularBlur;
          swY = swY - item.regularBlur;
        }

        // let swX = cX;
        //let swY = cY;

        /*
        if(imageName === "")
        {
          sw = 50-strokeWidth/2;
        }
        */

        // let r = `r="${sw}"`


        // let iW = imageZoom*swX*2;
        // let iH = imageZoom*swY*2;

        // Update the viewBox with the new values
        let viewBoxStr = `${newViewBoxX} ${newViewBoxY} ${newViewBoxWidth} ${newViewBoxHeight}`;


        // transform="translate(${cX-r},${cY-r})"

        // <path d="${d}" ${fill} ${stroke} opacity="${opacity}" />                                
        // <ellipse cx="${cX}" cy="${cY}" rx="${swX}" ry="${swY}"/>
        // <ellipse cx="${cX}" cy="${cY}" rx="${swX}" ry="${swY}" ${fill} ${stroke} opacity = "${opacity}" ${filterStr ? `filter="url(#${filterId})"` : ""}/>
        let d = ellipseToPath(cX, cY, swX, swY);

                
        if(imageName !="")
        {
          result.push(`

              <div id="${id}" ${aiInstruction} class="rectangle" 
                      style="padding:0;margin:0;left: ${x}px; top: ${y}px; width: ${w+strokeNum+1}px; height: ${h+strokeNum+1}px; z-index: ${zIndex}; overflow: hidden; transform: rotate(${-rotation}deg);">
                  
                    <svg width="${w}" height="${h}" overflow="visible" viewBox="${viewBoxStr}" ${onClick} ${popup} data-rotation="${-rotation}" data-large="${fullPath}">
                        <defs>
                            <clipPath id="clip-${id}">
                                <!-- Define your clipping path, in this case, a circle -->                                                                
                                <path d="${d}" ${fill} ${stroke} opacity="${opacity}" />                                
                            </clipPath>                            
                              ${filterStr}                                     
                        </defs>

                        <ellipse cx="${cX}" cy="${cY}" rx="${swX}" ry="${swY}" ${fill} ${stroke} opacity = "${opacity}" ${filterStr ? `filter="url(#${filterId})"` : ""}/>
                        <!-- Wrap the image in a <g> and apply the clip-path to the group -->
                        <g ${filterStr ? `filter="url(#${filterId})"` : ""} >
                          <g  clip-path="url(#clip-${id})" opacity = "${opacity}">
                              <image
                                  href="${fullPath}"
                                  x="${iX}"
                                  y="${iY}"
                                  width="${iW}"    <!-- Dynamically set the width based on zoom -->
                                  height="${iH}"   <!-- Dynamically set the height based on zoom -->   
                                  preserveAspectRatio="none"                                
                              />
                          </g>
                        </g>

                    </svg>
                  </div>                  
                    `);
        
        }
        else
        {
          result.push(`
            <div id="${id}" ${aiInstruction} class="rectangle"   style="padding:0;margin:0;left: ${x}px; top: ${y}px; width: ${w+strokeNum+1}px; height: ${h+strokeNum+1}px; z-index: ${zIndex};overflow: hidden; transform: rotate(${-rotation}deg);">
                <svg ${onClick} width="${w}" height="${h}" viewBox="${viewBoxStr}">
                    ${gradientDef}
                    <defs>
                      ${filterStr} 
                   </defs>
                    <path d="${d}" ${fillValue} ${stroke} opacity="${opacity}" ${filterStr ? `filter="url(#${filterId})"` : ""}/>                                                    
                </svg>        
            </div>`);
        }  
      } // end SvgEllipse

      if (item.subType === 'SvgRect') 
      {
  
    
        const { x, y, w, h, id: idT, zIndex, rotation, 
                imageName, description, keepAspect, enablePopup, 
                clickable, useLocal, localLink, externalLink,
                fillColor, strokeColor, strokeWidth,allowStroke,allowFill, fillAlpha, imagePanX, imagePanY, imageZoom, 
                iX,iY, iW, iH,
                cornerTL, cornerTR, cornerBR, cornerBL} = item;
        let id = (idT.trim() + `_${unique}`).trim();

        let filterId = `filter-${id}`;
        let filterStr = "";

        if (item.isBlur || item.isDropShadow) {
          filterStr = `
            <filter id="${filterId}" x="-50%" y="-50%" width="200%" height="200%">
              ${item.isDropShadow ? `<feDropShadow dx="${item.shadowOffsetX}" dy="${item.shadowOffsetY}" stdDeviation="${item.shadowBlur}" flood-color="${item.shadowColor}" />` : ""}
              ${item.isBlur ? `<feGaussianBlur stdDeviation="${item.regularBlur}" />` : ""}
            </filter>
          `;
        }

                
        let opacity = fillAlpha;
        let aiInstruction = "";
        if (description !== "") {
          aiInstruction = `data-ai-instruction="${description}"`;
        }
  
        let refresh = "";
        if (!preview) {
          refresh = "?v=" + new Date().getTime();
        }

        let fullPath = imageName;
        if (demo === true) {
            fullPath = `images/${imageName}` + refresh;
        } else {
            fullPath = `./${imageName}` + refresh;
        }

  
        let onClick = '';
        if(clickable)
        {
          let ll = localLink;
          let ee = externalLink;

          if(groupDepth !== 0)
          {
            ll = groupLocalLink;
            ee = groupExternalLink;
          }

          if(ll && ll != "")
          {
            let func = `goToPage('${ll}')`;
            onClick = `onClick="${func}"`;
          }
          if(ee && ee != "")
          {
            let func = `goToExternalPage('${ee}')`;
            onClick = `onClick="${func}"`;
          }
        }
  
  
        let fill = "";

        let gradientDef = "";
        let fillValue = fill;
        
        if (item.allowFill && item.fillMode === "gradient") {
        
          const angle = (item.gradientAngle || 0) * Math.PI / 180;
        
          const dx = Math.cos(angle);
          const dy = Math.sin(angle);
        
          const gradId = `grad-${id}`;
        
          gradientDef = `
            <defs>
              <linearGradient id="${gradId}" x1="${50 - dx * 50}%" y1="${50 - dy * 50}%" x2="${50 + dx * 50}%" y2="${50 + dy * 50}%">
                <stop offset="0%" stop-color="${item.gradientColor1}" />
                <stop offset="100%" stop-color="${item.gradientColor2}" />
              </linearGradient>
            </defs>
          `;
        
          fillValue = `fill="url(#${gradId})"`;
        
        } else if (item.allowFill) {
          fillValue = `fill="${item.fillColor}"`;
        } else {
          fillValue = `fill="transparent"`;
        }

        /*
        if(allowFill)
        {
          fill = `fill="${fillColor}"`;
        }
        else
        {
          fill = `fill="transparent"`;
        }
        */
  
        let stroke = "";

        if(allowStroke)
        {
          stroke = `stroke="${strokeColor}" stroke-width="${strokeWidth}"`;
        }

        let popup="";

        if(enablePopup===true)
        {
          popup = "class='popup-image'";
        }
                    
        // Calculate the new width/height of the viewBox based on zoom
        let newViewBoxWidth = w ;  // 160 is the original width of the rectangle
        let newViewBoxHeight = h; // 120 is the original height of the rectangle

        // Calculate the new origin of the viewBox (this is where pan will apply)
        let newViewBoxX = 0
        let newViewBoxY = 0
        

        let strokeNum  = parseInt(strokeWidth);
        if(allowStroke)
        {

          newViewBoxWidth += strokeNum;
          newViewBoxHeight += strokeNum;          
        }
                              
        // Update the viewBox with the new values
        let viewBoxStr = `${newViewBoxX} ${newViewBoxY} ${newViewBoxWidth} ${newViewBoxHeight}`;

        let reduceX = 0;
        let reduceY = 0;
        let a = newViewBoxWidth/2;
        let b = newViewBoxHeight/2;

        if(item.isDropShadow)
        {
          a = a-(Math.abs(item.shadowOffsetX) + item.shadowBlur);
          b = b-(Math.abs(item.shadowOffsetY) + item.shadowBlur);
        }
        if(item.isBlur)
        {
          a = a-item.regularBlur;
          b = b-item.regularBlur;          
        }

        reduceX = (newViewBoxWidth - 2*a)/2;
        reduceY = (newViewBoxHeight - 2*b)/2;

        if(allowStroke)
        {
          reduceX +=strokeNum/2;
          reduceY +=strokeNum/2;
        }

        let d = roundedRectPath(newViewBoxWidth,newViewBoxHeight, cornerTL, cornerTR,cornerBL,cornerBR,0, reduceX, reduceY);
        // transform="translate(${cX-r},${cY-r})"
        if(imageName !="")
        {
          result.push(`

              <div id="${id}" ${aiInstruction} class="rectangle" 
                      style="padding:0;margin:0;left: ${x-strokeNum/2}px; top: ${y-strokeNum/2}px; width: ${w+strokeNum+1}px; height: ${h+strokeNum+1}px; z-index: ${zIndex}; transform: rotate(${-rotation}deg);">
                  
                    <svg width="${newViewBoxWidth}" height="${newViewBoxHeight}" overflow="visible" viewBox="${viewBoxStr}" ${onClick} ${popup} data-rotation="${-rotation}" data-large="${fullPath}">
                        <defs>
                            <clipPath id="clip-${id}">
                                <!-- Define your clipping path, in this case, a rectangle -->
                                <path d="${d}" ${fill} ${stroke} opacity="${opacity}" />                                
                            </clipPath>
                            ${filterStr}                                     
                        </defs>
                  
                        <path d="${d}" ${fillValue} ${stroke} opacity="${opacity}" ${filterStr ? `filter="url(#${filterId})"` : ""}/>                                

                        <!-- Wrap the image in a <g> and apply the clip-path to the group -->
                        <g ${filterStr ? `filter="url(#${filterId})"` : ""}>
                          <g clip-path="url(#clip-${id})" opacity = "${opacity}">
                              <image
                                  href="${fullPath}"
                                  x="${iX}"
                                  y="${iY}"
                                  width="${iW}"    <!-- Dynamically set the width based on zoom -->
                                  height="${iH}"   <!-- Dynamically set the height based on zoom -->   
                                  preserveAspectRatio="none"                                
                              />
                          </g>
                        </g>                          
                        
                        
                    </svg>
                  </div>
                  
                    `);
        
        }
        else
        {
          result.push(`
            <div id="${id}" ${aiInstruction} class="rectangle"   style="padding:0;margin:0;left: ${x-strokeNum/2}px; top: ${y-strokeNum/2}px; width: ${w+strokeNum}px; height: ${h+strokeNum}px; overflow: visible; z-index: ${zIndex}; transform: rotate(${-rotation}deg);">
                <svg ${onClick} width="${newViewBoxWidth}" height="${newViewBoxHeight}" viewBox="${viewBoxStr}">
                      ${gradientDef}
                      <defs>
                          ${filterStr} 
                      </defs>
                
                      <path d="${d}" ${fillValue} ${stroke} opacity="${opacity}" ${filterStr ? `filter="url(#${filterId})"` : ""}/>                                
                      
                </svg>        
            </div>`);
        }  
      } // end SvgRect


      if (item.subType === 'SvgSquare') 
      {
  
    
        const { x, y, w, h, id: idT, zIndex, rotation, 
                imageName, description, keepAspect, enablePopup, 
                clickable, useLocal, localLink, externalLink,
                fillColor, strokeColor, strokeWidth,allowStroke,allowFill, fillAlpha, imagePanX, imagePanY, imageZoom, 
                iX,iY, iW, iH,
                cornerTL, cornerTR, cornerBR, cornerBL} = item;
        let id = (idT.trim() + `_${unique}`).trim();

        let filterId = `filter-${id}`;
        let filterStr = "";

        if (item.isBlur || item.isDropShadow) {
          filterStr = `
            <filter id="${filterId}" x="-50%" y="-50%" width="200%" height="200%">
              ${item.isDropShadow ? `<feDropShadow dx="${item.shadowOffsetX}" dy="${item.shadowOffsetY}" stdDeviation="${item.shadowBlur}" flood-color="${item.shadowColor}" />` : ""}
              ${item.isBlur ? `<feGaussianBlur stdDeviation="${item.regularBlur}" />` : ""}
            </filter>
          `;
        }
                
        let opacity = fillAlpha;
        let aiInstruction = "";
        if (description !== "") {
          aiInstruction = `data-ai-instruction="${description}"`;
        }
  
        let refresh = "";
        if (!preview) {
          refresh = "?v=" + new Date().getTime();
        }
        let fullPath = imageName;
        if (demo === true) {
            fullPath = `images/${imageName}` + refresh;
        } else {
            fullPath = `./${imageName}` + refresh;
        }

  
        let onClick = '';
        if(clickable)
        {
          let ll = localLink;
          let ee = externalLink;

          if(groupDepth !== 0)
          {
            ll = groupLocalLink;
            ee = groupExternalLink;
          }

          if(ll && ll != "")
          {
            let func = `goToPage('${ll}')`;
            onClick = `onClick="${func}"`;
          }
          if(ee && ee != "")
          {
            let func = `goToExternalPage('${ee}')`;
            onClick = `onClick="${func}"`;
          }
        }

        let fill = "";
        let gradientDef = "";
        let fillValue = fill;
        
        if (item.allowFill && item.fillMode === "gradient") {
        
          const angle = (item.gradientAngle || 0) * Math.PI / 180;
        
          const dx = Math.cos(angle);
          const dy = Math.sin(angle);
        
          const gradId = `grad-${id}`;
        
          gradientDef = `
            <defs>
              <linearGradient id="${gradId}" x1="${50 - dx * 50}%" y1="${50 - dy * 50}%" x2="${50 + dx * 50}%" y2="${50 + dy * 50}%">
                <stop offset="0%" stop-color="${item.gradientColor1}" />
                <stop offset="100%" stop-color="${item.gradientColor2}" />
              </linearGradient>
            </defs>
          `;
        
          fillValue = `fill="url(#${gradId})"`;
        
        } else if (item.allowFill) {
          fillValue = `fill="${item.fillColor}"`;
        } else {
          fillValue = `fill="transparent"`;
        }


        if(allowFill)
        {
          fill = `fill="${fillColor}"`;
        }
        else
        {
          fill = `fill="transparent"`;
        }
          
        let stroke = "";

        let strokeNum  = parseInt(strokeWidth);


        if(allowStroke)
        {
          stroke = `stroke="${strokeColor}" stroke-width="${strokeWidth}"`;
        }

        let popup="";

        if(enablePopup===true)
        {
          popup = "class='popup-image'";
        }

        // Calculate the new width/height of the viewBox based on zoom
        let newViewBoxWidth = w ;  // 160 is the original width of the rectangle
        let newViewBoxHeight = h; // 120 is the original height of the rectangle
        
        if(newViewBoxWidth < newViewBoxHeight)
        {
          newViewBoxHeight=newViewBoxWidth;
        }
        else
        {
          newViewBoxWidth=newViewBoxHeight;
        }

      
        // Calculate the new origin of the viewBox (this is where pan will apply)
        let newViewBoxX = 0
        let newViewBoxY = 0

        if(allowStroke)
        {

          newViewBoxWidth += strokeNum;
          newViewBoxHeight += strokeNum;          
        }
        

                                      
        // let r = `r="${sw}"`


        // let iW = imageZoom*swX*2;
        // let iH = imageZoom*swY*2;

        // Update the viewBox with the new values
        let viewBoxStr = `${newViewBoxX} ${newViewBoxY} ${newViewBoxWidth} ${newViewBoxHeight}`;
        let reduceX = 0;
        let reduceY = 0;
        let a = newViewBoxWidth/2;
        let b = newViewBoxHeight/2;

        if(item.isDropShadow)
        {
          a = a-(Math.abs(item.shadowOffsetX) + item.shadowBlur);
          b = b-(Math.abs(item.shadowOffsetY) + item.shadowBlur);
        }
        if(item.isBlur)
        {
          a = a-item.regularBlur;
          b = b-item.regularBlur;          
        }

        reduceX = (newViewBoxWidth - 2*a)/2;
        reduceY = (newViewBoxHeight - 2*b)/2;

        if(allowStroke)
        {
          reduceX +=strokeNum/2;
          reduceY +=strokeNum/2;
        }


        
        let d = roundedRectPath(newViewBoxWidth,newViewBoxHeight, cornerTL, cornerTR,cornerBL,cornerBR, 0, reduceX, reduceY);

        // <rect width="${ww}" height="${hh}" ${fill} ${stroke}  opacity = "${opacity}"/>                                                                        

        // transform="translate(${cX-r},${cY-r})"
        if(imageName !="")
        {
          result.push(`

              <div id="${id}" ${aiInstruction} class="rectangle" 
                      style="padding:0;margin:0;left: ${x-strokeNum/2}px; top: ${y-strokeNum/2}px; width: ${w+strokeNum+1}px; height: ${h+strokeNum+1}px; z-index: ${zIndex}; overflow: hidden; transform: rotate(${-rotation}deg);">
                  
                    <svg width="${newViewBoxWidth}" height="${newViewBoxHeight}" overflow="visible" viewBox="${viewBoxStr}" ${onClick} ${popup} data-rotation="${-rotation}" data-large="${fullPath}">
                        <defs>
                            <clipPath id="clip-${id}">
                                <!-- Define your clipping path, in this case, a circle -->
                                <path d="${d}" ${fill} ${stroke} opacity="${opacity}"  />                                
                            </clipPath>
                            ${filterStr} 
                        </defs>
                  
                        <path d="${d}" ${fill} ${stroke} opacity="${opacity}" ${filterStr ? `filter="url(#${filterId})"` : ""}/>
                        <!-- Wrap the image in a <g> and apply the clip-path to the group -->
                        <g ${filterStr ? `filter="url(#${filterId})"` : ""}>
                          <g clip-path="url(#clip-${id})" opacity = "${opacity}">
                              <image
                                  href="${fullPath}"
                                  x="${iX}"
                                  y="${iY}"
                                  width="${iW}"    <!-- Dynamically set the width based on zoom -->
                                  height="${iH}"   <!-- Dynamically set the height based on zoom -->   
                                  preserveAspectRatio="none"                                
                              />
                          </g>
                        </g>                                                
                    </svg>
                  </div>
                  
                    `);
        
        }
        else
        {
          result.push(`
            <div id="${id}" ${aiInstruction} class="rectangle"   style="padding:0;margin:0;left: ${x-strokeNum/2}px; top: ${y-strokeNum/2}px; width: ${w+strokeNum}px; height: ${h+strokeNum}px; z-index: ${zIndex};overflow: hidden; transform: rotate(${-rotation}deg);">
                <svg ${onClick} width="${newViewBoxWidth}" height="${newViewBoxHeight}" viewBox="${viewBoxStr}">
                  ${gradientDef}
                  <defs>
                    ${filterStr} 
                  </defs>

                  <path d="${d}" ${fillValue} ${stroke} opacity="${opacity}" ${filterStr ? `filter="url(#${filterId})"` : ""}/>                                      
                </svg>        
            </div>`);
        }  
      } // end SvgSquare

      if(item.subType === "Animate")
      {

        if(item.mPath === undefined && item.mObj === undefined)
        {

          const { x, y, w, h, id: idT, zIndex, richText, description } = item;
          let id = (idT.trim() + `_${unique}`).trim();
  
          let aiInstruction = "";
          if (description !== "") {
            aiInstruction = `data-ai-instruction="${description}"`;
          }
  
          let content = richText;
          let placeholderStyle = `
              background: rgba(128, 128, 128, 0.12);
              border: 1px dashed rgba(128, 128, 128, 0.45);
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: center;
              color: rgba(80, 80, 80, 0.7);
              font-family: Arial, sans-serif;
              font-size: 14px;
              text-align: center;
            `;
  
            content = "Svg Animation — add Rectangle to animate and Rectangle for path";
  
  
          result.push(`
            <div id="${id}" ${aiInstruction} class="rectangle text"
              style="left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex}; ${placeholderStyle}">
              ${content}
            </div>`);
        }
        else
        {
            handleAnimate(user, item,result, unique, demo, preview);
        }
      }  
    }

    if (item.type === 'SvgText') {
      const { x, y, w, h, id: idT, zIndex, rotation, description, fillColor, strokeColor, strokeWidth, 
              svgText, bound, allowStroke, allowFill, fillAlpha, clickable, useLocal, localLink, externalLink,} = item;
      let id = (idT.trim() + `_${unique}`).trim();

      let opacity = fillAlpha;


      let filterId = `filter-${id}`;
      let filterStr = "";

      if (item.isBlur || item.isDropShadow) {
        filterStr = `
          <filter id="${filterId}" x="-50%" y="-50%" width="200%" height="200%">
            ${item.isDropShadow ? `<feDropShadow dx="${item.shadowOffsetX}" dy="${item.shadowOffsetY}" stdDeviation="${item.shadowBlur}" flood-color="${item.shadowColor}" />` : ""}
            ${item.isBlur ? `<feGaussianBlur stdDeviation="${item.regularBlur}" />` : ""}
          </filter>
        `;
      }

      let aiInstruction = "";
      if (description !== "") {
        aiInstruction = `data-ai-instruction="${description}"`;
      }

      let onClick = '';
      if(clickable)
      {
        
        if(localLink && localLink != "")
        {
          let func = `goToPage('${localLink}')`;
          onClick = `onClick="${func}"`;
        }
        if(externalLink && externalLink != "")
        {
          let func = `goToExternalPage('${externalLink}')`;
          onClick = `onClick="${func}"`;
        }
      }



      let fill = "";

      let gradientDef = "";      
      let fillCss = "";
      
      if (item.allowFill && item.fillMode === "gradient") {
      
        const angle = (item.gradientAngle || 0) * Math.PI / 180;
      
        const dx = Math.cos(angle);
        const dy = Math.sin(angle);
      
        const gradId = `grad-${id}`;
      
        gradientDef = `
          <defs>
            <linearGradient id="${gradId}" x1="${50 - dx * 50}%" y1="${50 - dy * 50}%" x2="${50 + dx * 50}%" y2="${50 + dy * 50}%">
              <stop offset="0%" stop-color="${item.gradientColor1}" />
              <stop offset="100%" stop-color="${item.gradientColor2}" />
            </linearGradient>
          </defs>
        `;
      
        fill = `fill="url(#${gradId})"`;
        fillCss =`fill: url(#${gradId})`;
      
      } else if (item.allowFill) {
        fill = `fill="${item.fillColor}"`;
        fillCss =`fill: ${item.fillColor}`;
      } else {
        fill = `fill="transparent"`;
        fillCss = `fill: none`;
      }

      /*
      let fillCss = "";
      if(allowFill)
      {
        fill = `fill="${fillColor}"`;
        fillCss =`fill: ${fillColor}`;
      }
      else
      {
        fill = `fill="transparent"`;
        fillCss = `fill: none`;
      }
      */
        
      let stroke = "";
      let strokeCss = "";

      if(allowStroke)
      {
        stroke = `stroke="${strokeColor}" stroke-width="${strokeWidth}"`;
        strokeCss = `stroke: ${strokeColor}`;
      }
      else
      {
        strokeCss = `stroke: none`;
      }


      result.push(`            
        <div id="${id}" ${aiInstruction} class="svgrectangle" style="left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex}; transform: rotate(${-rotation}deg);">
          <style>
                #${id} svg path {${fillCss}; ${strokeCss}; stroke-width: ${strokeWidth}px; }
          </style>
          <svg width="100%" height="100%" viewBox="${0} ${0} ${w} ${h}" ${onClick}>
            ${gradientDef}
            <defs>
              ${filterStr} 
            </defs>

            <path d="${svgText}"  ${fill} ${stroke} opacity="${opacity}" ${filterStr ? `filter="url(#${filterId})"` : ""} />
          </svg>
        </div>`);
    }

    if (item.type === 'Prect') {
      // const { x, y, w, h, id: idT, zIndex, rotation, description, rPath, bound, fillColor, strokeColor, strokeWidth, imageName } = item;
      const { x, y, w, h, id: idT, zIndex, rotation, 
        imageName, rPath, path, description, keepAspect, enablePopup, 
        clickable, useLocal, localLink, externalLink,
        fillColor, strokeColor, strokeWidth,allowStroke,allowFill, imagePanX, imagePanY, imageZoom, 
        iX,iY, iW, iH} = item;

      let id = (idT.trim() + `_${unique}`).trim();


      let filterId = `filter-${id}`;
      let filterStr = "";

      if (item.isBlur || item.isDropShadow) {
        filterStr = `
          <filter id="${filterId}" x="-50%" y="-50%" width="200%" height="200%">
            ${item.isDropShadow ? `<feDropShadow dx="${item.shadowOffsetX}" dy="${item.shadowOffsetY}" stdDeviation="${item.shadowBlur}" flood-color="${item.shadowColor}" />` : ""}
            ${item.isBlur ? `<feGaussianBlur stdDeviation="${item.regularBlur}" />` : ""}
          </filter>
        `;
      }

      let refresh = "";
      if (!preview) {
        refresh = "?v=" + new Date().getTime();
      }
      
      let fullPath = imageName;
      if (demo === true) {
          fullPath = `images/${imageName}` + refresh;
      } else {
          fullPath = `./${imageName}` + refresh;
      }



      let aiInstruction = "";
      if (description !== "") {
        aiInstruction = `data-ai-instruction="${description}"`;
      }

      let onClick = '';
      if(clickable)
      {
        let ll = localLink;
        let ee = externalLink;

        if(groupDepth !== 0)
        {
          ll = groupLocalLink;
          ee = groupExternalLink;
        }

        if(ll && ll != "")
        {
          let func = `goToPage('${ll}')`;
          onClick = `onClick="${func}"`;
        }
        if(ee && ee != "")
        {
          let func = `goToExternalPage('${ee}')`;
          onClick = `onClick="${func}"`;
        }
      }
          
      let popup="";

      if(enablePopup===true)
      {
        popup = "class='popup-image'";
      }
      // Calculate the new width/height of the viewBox based on zoom
      let newViewBoxWidth = w ;  // 160 is the original width of the rectangle
      let newViewBoxHeight = h; // 120 is the original height of the rectangle
      
      // Calculate the new origin of the viewBox (this is where pan will apply)
      let newViewBoxX = 0
      let newViewBoxY = 0
      

      // Update the viewBox with the new values
      let viewBoxStr = `${newViewBoxX} ${newViewBoxY} ${newViewBoxWidth} ${newViewBoxHeight}`;
      
      // If imageName is provided, we use the first path for clipping
      

      const opacity = path[0]?.alpha;
      if (imageName !== "") 
      {
        

        const pathsHtml = rPath.map((pathObj, index) => {
          const stroke = path[index].allowStroke
          ? (path[index].strokeColor || "#000")
          : "none";
      
        const strokeWidth = path[index].allowStroke
          ? (path[index].strokeWidth || 1)
          : 0;
      
        const fill = path[index].allowFill
          ? (path[index].fillColor || "none")
          : "none";
      
        const opacity = (path[index].alpha !== undefined)
          ? path[index].alpha
          : 1;

          return `
            <path 
              d="${pathObj.d}" 
              stroke="${stroke}" 
              stroke-width="${strokeWidth}" 
              stroke-linecap="round"
              stroke-linejoin="round"
              fill="${fill}" 
              opacity="${opacity}"
              ${filterStr ? `filter="url(#${filterId})"` : ""}
            />              
          `;
        }).join("\n");

        // Only clip the image using the first path
        // const clipPath = rPath[0] ? `path('${rPath[0].d}')` : "";
        // ${rPath[0] ? `<path d="${rPath[0].d}" />` : ""}

        result.push (`
                  <div id="${id}" ${aiInstruction} class="rectangle" 
                  style="padding:0;margin:0;left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex}; overflow: hidden; transform: rotate(${-rotation}deg);">
              
                <svg width="${w}" height="${h}" overflow="visible" viewBox="${viewBoxStr}" ${onClick} ${popup} data-rotation="${-rotation}" data-large="${fullPath}">
                    <defs>
                        <clipPath id="clip-${id}">
                            <!-- Define clipping path using dynamic path data -->
                            ${pathsHtml}                 
                        </clipPath>
                        ${filterStr}
                    </defs>
              
                    <!-- Wrap the image in a <g> and apply the clip-path to the group -->
                    ${pathsHtml}
                    <g ${filterStr ? `filter="url(#${filterId})"` : ""}>
                      <g clip-path="url(#clip-${id})" opacity = "${opacity}">
                          <image
                              href="${fullPath}"
                              x="${iX}"
                              y="${iY}"
                              width="${iW}"    <!-- Dynamically set the width based on zoom -->
                              height="${iH}"   <!-- Dynamically set the height based on zoom -->   
                              preserveAspectRatio="none"                                
                          />
                      </g>
                    </g>                      
                </svg>
              </div>
              
        `);
      } else {


        const gDefs = rPath.map((pathObj, index) =>{
              const gradId = `grad-${id}-${index}`;
              let gradientDef = "";
              const angle = (path[index].gradientAngle || 0) * Math.PI / 180;
          
              const dx = Math.cos(angle);
              const dy = Math.sin(angle);
  
              gradientDef = `
              <defs>
                <linearGradient id="${gradId}" x1="${50 - dx * 50}%" y1="${50 - dy * 50}%" x2="${50 + dx * 50}%" y2="${50 + dy * 50}%">
                  <stop offset="0%" stop-color="${path[index].gradientColor1}" />
                  <stop offset="100%" stop-color="${path[index].gradientColor2}" />
                </linearGradient>
              </defs>
            `;

            return gradientDef;          
        }).join("\n");

        const pathsHtml = rPath.map((pathObj, index) => {

          const gradId = `grad-${id}-${index}`;

          let fillValue = "";
  
          if (path[index].allowFill && path[index].fillMode === "gradient") {
                          
          
            fillValue = `fill="url(#${gradId})"`;
          
          } else if (path[index].allowFill) {
            fillValue = `fill="${path[index].fillColor}"`;
          } else {
            fillValue = `fill="transparent"`;
          }
    

        const stroke = path[index].allowStroke
            ? (path[index].strokeColor || "#000")
            : "none";
        
          const strokeWidth = path[index].allowStroke
            ? (path[index].strokeWidth || 1)
            : 0;
        
          const fill = path[index].allowFill
            ? (path[index].fillColor || "none")
            : "none";
        
          const opacity = (path[index].alpha !== undefined)
            ? path[index].alpha
            : 1;
        
          return `
            <path 
              d="${pathObj.d}" 
              stroke="${stroke}" 
              stroke-width="${strokeWidth}" 
              stroke-linecap="round"
              stroke-linejoin="round"
              ${fillValue}
              opacity="${opacity}"
              ${filterStr ? `filter="url(#${filterId})"` : ""}
            />
          `;
        }).join("\n");


        /*
        // If no imageName, just render the paths in an SVG
        const pathsHtml = rPath.map((pathObj, index) => {

          return `
            <path 
              d="${pathObj.d}" 
              stroke="${pathObj.strokeColor}" 
              stroke-width="${pathObj.strokeWidth}" 
              fill="${pathObj.fillColor}" 
            />
          `;
        }).join("\n");
          */      
      

        result.push(`
          <div id="${id}" ${aiInstruction} class="svgrectangle" style="left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex}; transform: rotate(${-rotation}deg);">
            <svg width="100%" height="100%" viewBox="0 0 ${w} ${h}" preserveAspectRatio="xMidYMid meet" ${onClick}>
              ${gDefs}
              <defs>
                ${filterStr}
              </defs>
              ${pathsHtml}
            </svg>
          </div>
        `);
      }
    }

    if (item.type === 'Bezier') {

      const { x, y, w, h, id: idT, zIndex, rotation, 
        imageName, rPath, path, description, keepAspect, enablePopup, 
        clickable, useLocal, localLink, externalLink,
        fillColor, strokeColor, strokeWidth,allowStroke,allowFill, imagePanX, imagePanY, imageZoom, 
        iX,iY, iW, iH} = item;

      let id = (idT.trim() + `_${unique}`).trim();

      let filterId = `filter-${id}`;
      let filterStr = "";

      if (item.isBlur || item.isDropShadow) {
        filterStr = `
          <filter id="${filterId}" x="-50%" y="-50%" width="200%" height="200%">
            ${item.isDropShadow ? `<feDropShadow dx="${item.shadowOffsetX}" dy="${item.shadowOffsetY}" stdDeviation="${item.shadowBlur}" flood-color="${item.shadowColor}" />` : ""}
            ${item.isBlur ? `<feGaussianBlur stdDeviation="${item.regularBlur}" />` : ""}
          </filter>
        `;
      }

      let refresh = "";
      if (!preview) {
        refresh = "?v=" + new Date().getTime();
      }

      let fullPath = imageName;
      if (demo === true) {
          fullPath = `images/${imageName}` + refresh;
      } else {
          fullPath = `./${imageName}` + refresh;
      }

      let aiInstruction = "";
      if (description !== "") {
        aiInstruction = `data-ai-instruction="${description}"`;
      }

      let onClick = '';
      if(clickable)
      {
        let ll = localLink;
        let ee = externalLink;

        if(groupDepth !== 0)
        {
          ll = groupLocalLink;
          ee = groupExternalLink;
        }

        if(ll && ll != "")
        {
          let func = `goToPage('${ll}')`;
          onClick = `onClick="${func}"`;
        }
        if(ee && ee != "")
        {
          let func = `goToExternalPage('${ee}')`;
          onClick = `onClick="${func}"`;
        }

      }
          
      let popup="";

      if(enablePopup===true)
      {
        popup = "class='popup-image'";
      }
      // Calculate the new width/height of the viewBox based on zoom
      let newViewBoxWidth = w ;  // 160 is the original width of the rectangle
      let newViewBoxHeight = h; // 120 is the original height of the rectangle
      
      // Calculate the new origin of the viewBox (this is where pan will apply)
      let newViewBoxX = 0
      let newViewBoxY = 0
      

      // Update the viewBox with the new values
      let viewBoxStr = `${newViewBoxX} ${newViewBoxY} ${newViewBoxWidth} ${newViewBoxHeight}`;

      
      // If imageName is provided, we use the first path for clipping
      let opacity = path[0]?.alpha;
      if (imageName !== "") 
      {        
        const pathsHtml = rPath.map((pathObj, index) => {
          const stroke = path[index].allowStroke
          ? (path[index].strokeColor || "#000")
          : "none";
      
        const strokeWidth = path[index].allowStroke
          ? (path[index].strokeWidth || 1)
          : 0;
      
        const fill = path[index].allowFill
          ? (path[index].fillColor || "none")
          : "none";
      
        const opacity = (path[index].alpha !== undefined)
          ? path[index].alpha
          : 1;

          return `
            <path 
              d="${pathObj.d}" 
              stroke="${stroke}" 
              stroke-width="${strokeWidth}" 
              fill="${fill}" 
              opacity="${opacity}"
              stroke-linecap="round"
              stroke-linejoin="round"

              ${filterStr ? `filter="url(#${filterId})"` : ""}              
            />
          `;
        }).join("\n");

        // Only clip the image using the first path
        const clipPath = rPath[0] ? `path('${rPath[0].d}')` : "";


        result.push (`
                  <div id="${id}" ${aiInstruction} class="rectangle" 
                  style="padding:0;margin:0;left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex}; overflow: hidden; transform: rotate(${-rotation}deg);">
              
                <svg width="${w}" height="${h}" overflow="visible" viewBox="${viewBoxStr}" ${onClick} ${popup} data-rotation="${-rotation}" data-large="${fullPath}">
                    <defs>
                        <clipPath id="clip-${id}" >
                            <!-- Define clipping path using dynamic path data -->
                            ${pathsHtml}                            
                        </clipPath>
                        ${filterStr}
                    </defs>
              
                    ${pathsHtml}
                    <!-- Wrap the image in a <g> and apply the clip-path to the group -->
                    <g ${filterStr ? `filter="url(#${filterId})"` : ""}>
                      <g clip-path="url(#clip-${id})" opacity = "${opacity}">
                          <image
                              href="${fullPath}"
                              x="${iX}"
                              y="${iY}"
                              width="${iW}"    <!-- Dynamically set the width based on zoom -->
                              height="${iH}"   <!-- Dynamically set the height based on zoom -->   
                              preserveAspectRatio="none"                                
                          />
                      </g>
                    </g>                      
                </svg>
              </div>
              
        `);
      } else {
        // If no imageName, just render the paths in an SVG

        const gDefs = rPath.map((pathObj, index) =>{
              const gradId = `grad-${id}-${index}`;
              let gradientDef = "";
              const angle = (path[index].gradientAngle || 0) * Math.PI / 180;
          
              const dx = Math.cos(angle);
              const dy = Math.sin(angle);

              gradientDef = `
              <defs>
                <linearGradient id="${gradId}" x1="${50 - dx * 50}%" y1="${50 - dy * 50}%" x2="${50 + dx * 50}%" y2="${50 + dy * 50}%">
                  <stop offset="0%" stop-color="${path[index].gradientColor1}" />
                  <stop offset="100%" stop-color="${path[index].gradientColor2}" />
                </linearGradient>
              </defs>
            `;

            return gradientDef;          
        }).join("\n");



        const pathsHtml = rPath.map((pathObj, index) => {
          const gradId = `grad-${id}-${index}`;
          let fillValue = "";
  
          if (path[index].allowFill && path[index].fillMode === "gradient") {                                    
            fillValue = `fill="url(#${gradId})"`;          
          } else if (path[index].allowFill) {
            fillValue = `fill="${path[index].fillColor}"`;
          } else {
            fillValue = `fill="transparent"`;
          }

          const stroke = path[index].allowStroke
            ? (path[index].strokeColor || "#000")
            : "none";
        
          const strokeWidth = path[index].allowStroke
            ? (path[index].strokeWidth || 1)
            : 0;
        
          const fill = path[index].allowFill
            ? (path[index].fillColor || "none")
            : "none";
        
          const opacity = (path[index].alpha !== undefined)
            ? path[index].alpha
            : 1;
        
          return `
            <path 
              d="${pathObj.d}" 
              stroke="${stroke}" 
              stroke-width="${strokeWidth}" 
              ${fillValue}
              stroke-linecap="round"
              stroke-linejoin="round"
              opacity="${opacity}"
              ${filterStr ? `filter="url(#${filterId})"` : ""}
            />
          `;
        }).join("\n");
        
        result.push(`
          <div id="${id}" ${aiInstruction} class="svgrectangle" style="left: ${x}px; top: ${y}px; width: ${w}px; height: ${h}px; z-index: ${zIndex}; transform: rotate(${-rotation}deg);">
            <svg width="100%" height="100%" viewBox="0 0 ${w} ${h}" preserveAspectRatio="xMidYMid meet" ${onClick}>
              ${gDefs}
              <defs>
                ${filterStr}
              </defs>                
              ${pathsHtml}
            </svg>
          </div>
        `);
      }
    }

    // Handle the Group item and add its children to the queue
    /*
    if (item.type === "Group") {
      let children = item.children;
      children.forEach(child => {
        // Push children to the queue for further processing
        queue.push(child);
      });
    }
      */


      // Handle Group
    if (item.type === "Group") 
    {
        // Push end marker FIRST

        /*
        const { x, y, w, h, id: idT, zIndex, rotation, 
          imageName, rPath, description, keepAspect, enablePopup, 
          clickable, useLocal, localLink, externalLink,
          fillColor, strokeColor, strokeWidth,allowStroke,allowFill, imagePanX, imagePanY, imageZoom, 
          iX,iY, iW, iH} = item;
  
        let id = (idT.trim() + `_${unique}`).trim();
        */

        const isTopLevelGroup = groupDepth === 0;

        if(groupDepth === 0)
        {
          groupExternalLink = item.externalLink;
          groupLocalLink = item.localLink;
        }

        groupDepth++;
      
        
        let rectHtml = drawGroupRect(user, item, unique, demo, preview);
        result.push(`          
            ${rectHtml}
          `          
          );
          

  
        queue.unshift("__END_GROUP__");

        // Then push children in reverse order
        // (so they process in correct order)
        for (let i = item.children.length - 1; i >= 0; i--) 
        {
          const child = item.children[i];
          const childData = {
            ...child,
            parent:item
          }
          // queue.unshift(item.children[i]);
          queue.unshift(childData);
        }

      continue;
    }


  }
  
  return result.join('');
}


function beautifyHtml(htmlString) {
    return beautify(htmlString, { 
        indent_size: 2, // Number of spaces for indentation
        space_in_empty_paren: true, // Adds spaces inside empty parentheses
        preserve_newlines: true, // Preserves line breaks
        max_preserve_newlines: 3 // Limit how many line breaks to preserve
    });
}


function generateDeviceScript(t, devices, pagesForDevice, pages) {
  let updateVisibleStr = '';
  let goToPageStr = '';
  let goToExternalPageStr = '';

  const seen = new Set();
  let pageOrder = [];

  if(t.navigation.method !=='scroll')
  {
    pages.forEach(page => {

      const [prefix, numStr] = page.pageId.split("_");
        
      if (!seen.has(prefix)) {
        seen.add(prefix);
        pageOrder.push(prefix);
      }
    });
  }

  if(t.navigation.method === 'scroll')
  {
    updateVisibleStr = `            
            // Function to show pages for current device and hide the rest
            function updateVisiblePages() 
            {
                const width = window.innerWidth;
                const category = getDeviceCategory(width);
                const pagesToShow = pagesForDevice[category] || [];

                // First, hide all pages
                const allPages = document.querySelectorAll('.page');  // Assuming all pages have the class 'page'
                allPages.forEach(page => {
                    page.style.display = 'none';  // Hide all pages
                    
                });
            
                for(let i = 0; i< pagesToShow.length; i++)
                {          
                  let id = "page-" + pagesToShow[i].id;
                  let el = document.getElementById(id);
                  if(el != null)
                  {
                    el.style.display = "block";
                  }

                } 
            }
            `

            goToPageStr = `function goToPage(link)
                            {
                              console.log("link", link);                        
                              const width = window.innerWidth;
                              const category = getDeviceCategory(width);
                              const pagesToShow = pagesForDevice[category] || [];                        
              
                              let page = link;
                              const found = pagesToShow.find((str)=>{ 
                                  const [prefix, num] = str.id.split('_');
                                  if(prefix === page)
                                  {
                                    return true;
                                  }
                              });
                              console.log("Just before found");
                              if(found)
                              {                                
                                let id = "page-" + found.id;

                                const el = document.getElementById(id);
                                if (el) {
                                  el.scrollIntoView({
                                    behavior: "smooth",
                                    block: "start"
                                  });
                                }
                              }                                             
                            }
                        `;

              goToExternalPageStr = `function goToExternalPage(link)
                        {
                          window.location.href = link;                          
                        }
                    `;

  }
  else
  {
    updateVisibleStr = `            
            // Function to show pages for current device and hide the rest
            function updateVisiblePages() 
            {
                const width = window.innerWidth;
                const category = getDeviceCategory(width);
                const pagesToShow = pagesForDevice[category] || [];

                // First, hide all pages
                const allPages = document.querySelectorAll('.page');  // Assuming all pages have the class 'page'
                allPages.forEach(page => {
                    page.style.display = 'none';  // Hide all pages
                    
                });
            
                console.log(JSON.stringify(pagesToShow));

                let page = pageOrder[currentPage];
                const found = pagesToShow.find((str)=>{ 
                    const [prefix, num] = str.id.split('_');
                    if(prefix === page)
                    {
                      return true;
                    }
                });
                if(found)
                {
                  let id = "page-" + found.id;
                  let el = document.getElementById(id);
                  if(el != null)
                  {
                    el.style.display = "block";
                  }    
                }
            }
            `
            goToPageStr = `function goToPage(link)
            {
              console.log("link", link);
        
        
              let newPage = pageOrder.findIndex(id => id === link);
        
              if(newPage !== -1)
              {
                currentPage = newPage;
                updateVisiblePages();
          
              }
            }
        `;
  }

  let scriptString = `
<script>
(function() {

    let currentPage = 0;
    let devices = ${JSON.stringify(devices)};
    let pagesForDevice = ${JSON.stringify(pagesForDevice)};
    let pageOrder = ${JSON.stringify(pageOrder)};


    window.goToPage=${goToPageStr};
    window.goToExternalPage=${goToExternalPageStr};

    function getDeviceCategory() {
      // Iterate through the devices array and create a media query for each device
      for (let i = 0; i < devices.length; i++) {
        const device = devices[i];
        
        // Build a media query based on minWidth and maxWidth

        const mediaQuery = "(min-width: " + device.minWidth + "px) and (max-width: " + device.maxWidth + "px)";
        
        // Use matchMedia to check if the device matches the media query
        const mediaQueryList = window.matchMedia(mediaQuery);
        
        if (mediaQueryList.matches) {
          console.log(device.name);
          return device.name; // Return the device name if it matches
        }
      }
      console.log("No Device Width, Pick largest");      
      // return ""; // Return an empty string if no device matches
      let largest = devices[devices.length-1].name;
      return largest;
    }
    
    ${updateVisibleStr}

    // Listen for changes in the media query directly
    devices.forEach(device => {
      const mediaQuery = "(min-width: " + device.minWidth + "px) and (max-width: " + device.maxWidth + "px)";
      const mediaQueryList = window.matchMedia(mediaQuery);
  
      // Listen for changes in the media query
      mediaQueryList.addEventListener('change', updateVisiblePages);
    });

    // Run on load and resize
    window.addEventListener("load", updateVisiblePages);
    window.addEventListener("resize", updateVisiblePages);


    /*java script for image pop up*/
    const popup = document.getElementById("imagePopup");
    const popupImg = document.getElementById("popupImg");
    const closeBtn = document.getElementById("popupClose");

    document.querySelectorAll(".popup-image").forEach(el => {
      el.addEventListener("click", () => {
        popup.style.display = "flex";
    
        const largeSrc = el.dataset.large || el.getAttribute("src");
    
        if (largeSrc) {
          popupImg.src = largeSrc;
        }
        const rotation = el.dataset.rotation;

          if (rotation) {
            popupImg.style.transform = "rotate(" + rotation + "deg)";            
          } else {
            popupImg.style.transform = "none";
          }
      });
    });
    
    closeBtn.addEventListener("click", () => {
      popup.style.display = "none";
    });

    popup.addEventListener("click", e => {
      if (e.target === popup) {
        popup.style.display = "none";
      }
    });

    })();
</script>
  `;
  return scriptString;
}

function writePages(user, mediaString, pages, scriptString, devices, title)
{
    let pageSize = [];

    devices.forEach ((device) => {        
       let pageSizeCss = ` 
                .page.${device.name} 
                {
                  width: ${device.maxWidth}px;
                }`;
        pageSize.push(pageSizeCss);
    });

   
    
    let base = `https://myaiweb.ca/${user}/`;
    if (demo === true) 
    {
      base = "https://ait.myaiweb.ca";      
    }
    
    
    let baseTag = `<base id="baseUrl" href="${base}">`

    let version = "?v="  + new Date().getTime();
   
    // base.href = window.location.origin + "/";
   
    let htmlPage =
        `
        <!DOCTYPE html>
        <html lang="en">
        <head>
    
            ${baseTag}
            <script>
                const base = document.getElementById("baseUrl");

                let url = new URL(window.location.href);
                /*
                if (!url.pathname.endsWith("/")) {
                  url.pathname += "/";
                }
                */
                base.href = url.origin + "/${user}/";
                window.parentOrigin = url.origin;

                console.log("Base Ref:", base.href);
            </script>

            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>${title}</title>
            <style>
                body {
                  margin:0;
                  /*used this to control browser background color*/
                  background-color: ${bodyColor};

                }
                #content {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
                .page {
                    display: none;
                    position: relative;
                    width: 480px;                    
                    /*margin-bottom: 20px;*/ /* Optional spacing between pages */
                    flex-shrink: 0;
                    overflow:hidden;
                }
                ${pageSize.join('\n')}
                
                .rectangle {
                    position: absolute;
                }
                .svgrectangle
                {
                    position: absolute;                   
                }

                .text {
                    overflow: auto;
                }
                .image {
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                }

                #imagePopup {
                  display: none;
                  position: fixed;
                  z-index: 9999;
                  left: 0;
                  top: 0;
                  width: 100%;
                  height: 100%;
                  background: rgba(0,0,0,0.85);
                  justify-content: center;
                  align-items: center;
                }
                
                #imagePopup img {
                  max-width: 95vw;
                  max-height: 95vh;
                  object-fit: contain;
                  border-radius: 8px;
                }
                
                #popupClose {
                  position: absolute;
                  top: 20px;
                  right: 30px;
                  font-size: 40px;
                  color: white;
                  cursor: pointer;
                }
                
                /* Font Families */
                .ql-font-sans-serif {
                  font-family: sans-serif;
                }
                
                .ql-font-serif {
                  font-family: serif;
                }
                
                .ql-font-monospace {
                  font-family: monospace;
                }
                
                .ql-font-arial {
                  font-family: Arial, sans-serif;
                }
                
                .ql-font-times-new-roman {
                  font-family: "Times New Roman", serif;
                }
                
                .ql-font-roboto {
                  font-family: 'Roboto', sans-serif;
                }
                
                .ql-font-comic-sans {
                  font-family: 'Comic Sans MS', sans-serif;
                }
                @font-face {
                  font-family: "ComicNeue";
                  src: url("/userfonts/ComicNeue-Regular.woff2${version}") format("woff2");
                  font-weight: 400;
                  font-style: normal;
                  font-display: swap;
                }
                @font-face {
                  font-family: "BebasNeue";
                  src: url("/userfonts/BebasNeue-Regular.woff2${version}") format("woff2");
                  font-weight: 400;
                  font-style: normal;
                  font-display: swap;
                }
                @font-face {
                  font-family: "ComicRelief";
                  src: url("/userfonts/ComicRelief-Regular.woff2${version}") format("woff2");
                  font-weight: 400;
                  font-style: normal;
                  font-display: swap;
                }
                @font-face {
                  font-family: "Lora";
                  src: url("/userfonts/Lora-Regular.woff2") format("woff2");
                  font-weight: 400;
                  font-style: normal;
                  font-display: swap;
                }
                @font-face {
                  font-family: "Montserrat";
                  src: url("/userfonts/Montserrat-Regular.woff2") format("woff2");
                  font-weight: 400;
                  font-style: normal;
                  font-display: swap;
                }
                @font-face {
                  font-family: "Oswald";
                  src: url("/userfonts/Oswald-Regular.woff2") format("woff2");
                  font-weight: 400;
                  font-style: normal;
                  font-display: swap;
                }
                @font-face {
                  font-family: "Pacifico";
                  src: url("/userfonts/Pacifico-Regular.woff2") format("woff2");
                  font-weight: 400;
                  font-style: normal;
                  font-display: swap;
                }
                @font-face {
                  font-family: "PlayfairDisplay";
                  src: url("/userfonts/PlayfairDisplay-Regular.woff2") format("woff2");
                  font-weight: 400;
                  font-style: normal;
                  font-display: swap;
                }
                @font-face {
                  font-family: "Roboto";
                  src: url("/userfonts/Roboto-Regular.woff2") format("woff2");
                  font-weight: 400;
                  font-style: normal;
                  font-display: swap;
                }
                @font-face {
                  font-family: "Satoshi";
                  src: url("/userfonts/Satoshi-Regular.woff2") format("woff2");
                  font-weight: 400;
                  font-style: normal;
                  font-display: swap;
                }
              
                .ql-font-comicneue {
                    font-family: "ComicNeue";
                }
                .ql-font-bebasneue {
                  font-family: "BebasNeue";
                }
                .ql-font-comicrelief {
                  font-family: "ComicRelief";
                }
                .ql-font-lora {
                  font-family: "Lora";
                }
                .ql-font-montserrat {
                  font-family: "Montserrat";
                }
                .ql-font-oswald {
                  font-family: "Oswald";
                }
                .ql-font-pacifico {
                  font-family: "Pacifico";
                }
                .ql-font-playfairdisplay {
                  font-family: "PlayfairDisplay";
                }
                .ql-font-roboto {
                  font-family: "Roboto";
                }
                .ql-font-satoshi {
                  font-family: "Satoshi";
                }
                
                /* Example media query scaling */
                @media (max-width: 576px) {
                  #popupClose {
                    font-size: 30px;
                    top: 10px;
                    right: 15px;
                  }
                }                                
                ${mediaString}
            </style>
        </head>
        <body>
            <div id="content">
                ${pages}
            </div>            

            <div id="imagePopup">
              <span id="popupClose">&times;</span>
              <img id="popupImg">
            </div>

            ${scriptString}
        </body>
        </html>`;

        // const filePath = `${user.webId}`;
        // const fileName = path.join(filePath, "test.html");
        let fileContent = htmlPage; // beautify(htmlPage);    

        // console.log(fileContent);
        // fsb.writeFile(fileName, fileContent);

        return fileContent;
}


// module.exports={toHtml}